import { Link } from "react-router-dom";
import { testimonials, stats } from "@/mocks/site";
import { principles } from "@/mocks/about";

export default function WhySection() {
  return (
    <section className="overflow-hidden bg-primary-950 text-background-50">
      <div className="mx-auto max-w-container px-4 py-12 md:px-6 md:py-16">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-widest text-secondary-300">我们的立场</span>
          <h2 className="mt-2 text-2xl text-background-50 md:text-3xl">冷静吃瓜，也是一种专业</h2>
          <p className="mt-3 text-sm leading-7 text-background-200/90">
            热瓜雷达相信，真正有价值的吃瓜不是站队和情绪宣泄，而是把信息梳理清楚、
            把规律看清，让每个人都能在信息洪流里做出自己的判断。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {principles.map((p) => (
            <div key={p.title} className="rounded-2xl border border-background-50/15 bg-background-50/5 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-500/20 text-secondary-300">
                <i className={`${p.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-background-50">{p.title}</h3>
              <p className="mt-2 text-sm leading-6 text-background-200/85">{p.text}</p>
            </div>
          ))}
        </div>

        {/* 口碑 */}
        <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="grid grid-cols-2 gap-3">
              {stats.map((s) => (
                <div key={s.label} className="rounded-2xl bg-background-50/5 p-4 text-center">
                  <span className="font-display text-2xl text-secondary-300">{s.value}</span>
                  <p className="mt-1 text-xs text-background-200/80">{s.label}</p>
                </div>
              ))}
            </div>
            <Link
              to="/about"
              className="mt-5 inline-flex w-full items-center justify-center gap-1 whitespace-nowrap rounded-full bg-secondary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-secondary-600"
            >
              认识热瓜雷达 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="space-y-4 lg:col-span-8">
            {testimonials.map((t) => (
              <figure key={t.name} className="flex flex-col gap-3 rounded-2xl border border-background-50/15 bg-background-50/5 p-5 sm:flex-row sm:items-start">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50">
                  <i className="ri-double-quotes-l"></i>
                </span>
                <div>
                  <blockquote className="text-sm leading-7 text-background-100/95">{t.quote}</blockquote>
                  <figcaption className="mt-2 flex items-center gap-2 text-xs text-background-200/80">
                    <span className="font-medium text-background-50">{t.name}</span>
                    <span>· {t.role}</span>
                  </figcaption>
                </div>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}